
(function() {
  var result = { translations: { "it": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} gg", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}g", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, est. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "it": "static-7.1303"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1303",
    "ar-eg": "static-7.1303",
    "bg": "static-7.1303",
    "bn": "static-7.1303",
    "ca-es": "static-7.1303",
    "cs": "static-7.1303",
    "da": "static-7.1303",
    "de": "static-7.1303",
    "el": "static-7.1303",
    "en-gb": "static-7.1303",
    "en": "static-7.1303",
    "es-mx": "static-7.1303",
    "es": "static-7.1303",
    "et": "static-7.1303",
    "fi": "static-7.1303",
    "fr-ca": "static-7.1303",
    "fr": "static-7.1303",
    "he-il": "static-7.1303",
    "hi": "static-7.1303",
    "hr": "static-7.1303",
    "hu": "static-7.1303",
    "id": "static-7.1303",
    "it": "static-7.1303",
    "ja": "static-7.1303",
    "ko": "static-7.1303",
    "lt": "static-7.1303",
    "ms": "static-7.1303",
    "nl": "static-7.1303",
    "no": "static-7.1303",
    "pl": "static-7.1303",
    "pt-br": "static-7.1303",
    "pt-pt": "static-7.1303",
    "ro": "static-7.1303",
    "ru": "static-7.1303",
    "sk": "static-7.1303",
    "sl": "static-7.1303",
    "sv": "static-7.1303",
    "th": "static-7.1303",
    "tl": "static-7.1303",
    "tr": "static-7.1303",
    "uk": "static-7.1303",
    "vi": "static-7.1303",
    "x-pseudo": "static-7.1303",
    "zh-cn": "static-7.1303",
    "zh-hk": "static-7.1303",
    "zh-tw": "static-7.1303"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:it', {version: 'static-7.1303'}); }
})();


